import React,{useState,useEffect} from 'react';
import queryString from 'query-string';
import {useNavigate,useLocation} from 'react-router-dom';
import{autoLoginUser} from '../../actions/LoginActions'
import {setStorage} from '../../config/Utils';
import ReactLoading from 'react-loading';

const AutoLoginDashboard = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [token,setToken]=useState({name:'token',value:'',error:'',isRequired:true})
    const [email,setEmail]=useState({name:'email',value:'',error:'',isRequired:true})
    const [loading,setLoading] = useState(false)
    
   
    useEffect(()=>{
        const qParams = queryString.parse(location.search);
        if(qParams!==null){
            setToken({...token,value:qParams.t})
            setEmail({...email,value:qParams.email})
            setStorage("token",qParams.t);
            autoLoginUserFromLink(qParams.t,qParams.email)
        }
    },[])

    const autoLoginUserFromLink=async(token,email)=>{
        const data={
            token:token,
            email:email,
        }
        autoLoginUser(data).then(res => {
            setLoading(true)
            if (res.status) {
                setLoading(false)
                navigate('/dashboard');
            }
        })
    }
   
  return (
   <>
    {loading &&<div className="screenLoader"><ReactLoading type={"bars"} width={80}  color={"#20367f"}/></div>}
   </>
  )
}

export default AutoLoginDashboard
